import { render, staticRenderFns } from "./FranchiseeElement.vue?vue&type=template&id=673eb9bb"
import script from "./FranchiseeElement.vue?vue&type=script&lang=js"
export * from "./FranchiseeElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports